import { onMounted, onUnmounted } from 'vue'
import { EventBus } from '@/event-bus'

export function useOnNewEntity (fn) {
    onMounted(() => EventBus.$on('shortcut:newEntity', fn))
    onUnmounted(() => EventBus.$off('shortcut:newEntity', fn))
}
